<template>
  <v-row>
    <v-col v-for="item in items" :key="item.key">
      <h5 class="ma-0 my-2"><img :src="item.url"> <span>{{ item.title }}</span></h5>
      <p class="ma-0 cut-text">{{ getCompanyContact(item.key) }}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['contacts'],

  data: () => ({
    items: [
      {
        title: 'Телефон',
        url: '/company-phone.svg',
        key: 'phone'
      },
      {
        title: 'E-mail',
        url: '/company-email.svg',
        key: 'email'
      },
      {
        title: 'Сайт',
        url: '/company-site.svg',
        key: 'site'
      },
    ]
  }),

  methods: {
    getCompanyContact(type) {
      if (this.contacts != null) {
        let contact = this.contacts.filter(contact => contact.type == type);

        if (contact.length > 0) {
          return contact[0].value;
        }

        return '';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .cut-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>